export default {
  frontRoutes: [
    {
      path: "/index/rec-periods",
      name: "IndexRecommendPeriods",
      component: () =>
        import(
          /* webpackChunkName: "periods" */ "../views/periods/Periods.vue"
        ),
    },
    {
      path: "/periods",
      name: "Periods",
      component: () =>
        import(
          /* webpackChunkName: "periods" */ "../views/periods/Periods.vue"
        ),
    },
    {
      path: "/periods/:id",
      name: "PeriodsDetail",
      component: () =>
        import(
          /* webpackChunkName: "periods" */ "../views/periods/PeriodsDetail.vue"
        ),
    },
  ],
  memberRoutes: [
    {
      path: "/member/periods",
      name: "MemberPeriods",
      component: () =>
        import(
          /* webpackChunkName: "periods" */ "../views/periods/MemberPeriods.vue"
        ),
      meta: {
        root: true,
        requireAuth: true,
        title: route => {
          if (route.query.tab == "otn" || route.query.tab == "oto_m") {
            return "我的约排课";
          } else if (route.query.tab == "class") {
            return "班课";
          } else {
            return "我的课时包";
          }
        },
      },
    },
    {
      path: "/member/periods/:id",
      name: "MemberPeriodsOutline",
      component: () =>
        import(
          /* webpackChunkName: "periods" */ "../views/periods/Outline.vue"
        ),
      meta: {
        requireAuth: true,
        title: "我的课时包",
      },
    },
    {
      path: "/memberCommunication",
      name: "PeriodsMemberOtoCommunication",
      component: () =>
        import(
          /* webpackChunkName: "periods" */ "../views/periods/PeriodsMemberOtoCommunication.vue"
        ),
      meta: {
        title: "沟通记录",
      },
    },
  ],
};
